




























import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import LoadingCircle from '@/components/loading-circle.vue'; 

@Component({
  components: {
    LoadingCircle
  }
})
export default class LoadingBlock extends Vue {
  @Prop({ default: false }) 
  conditional!: boolean;

  get visible() {
    return !this.conditional || this.$store.state.table.progressBlockVisible;
  }
}
